import type {ProgramPreparation} from '../domain/audition-plan';
export function repertoireSummary(minutes:(number|undefined)[],limit:number|null,videoSeconds?:number) {
 if(!minutes.length||minutes.some(v=>v==null))return '곡 길이를 모두 넣으면 대조해요';
 const sum=minutes.reduce<number>((n,v)=>n+(v??0),0);
 if(limit!=null&&sum*60>limit)return `곡 합이 제한보다 ${(sum-limit/60).toFixed(1)}분 길어요. 발췌 허용 여부를 요강에서 확인하세요`;
 if(videoSeconds!=null&&Math.abs(sum*60-videoSeconds)>60)return `곡 합 ${sum}분과 영상 길이가 1분 이상 달라요. 곡 순서와 여백을 직접 확인하세요`;
 return `곡 길이 합 ${sum}분 · ${limit==null?'요강 길이 제한을 확인하세요':'입력한 길이 안에 들어가요'}`;
}
export function RepertoireSummary({plan,limit,videoSeconds}:{plan:ProgramPreparation;limit:number|null;videoSeconds?:number}){return <p className="safety-copy">{repertoireSummary(plan.repertoire.map(r=>r.durationMinutes),limit,videoSeconds)}</p>;}
